































import { Component, Vue } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import mapStore from "@/store/mapStore";
import MapFilters from "@/components/Map/MapFilters.vue";
import { reaction } from "mobx";

@Observer
@Component({ components: { MapFilters } })
export default class MapFiltersContainer extends Vue {
  expasionPanelModel? = 0;
  mapStore = mapStore;
  dispose?: () => void;

  mounted() {
    this.$watch("expasionPanelModel", value => {
      mapStore.isDesktopFilterExpanded = value === 0;
    });

    const disposeOnFilterExpandedChanged = reaction(
      () => mapStore.isDesktopFilterExpanded,
      (expasionPanelModel: boolean) => {
        if (expasionPanelModel) this.expasionPanelModel = 0;
        else this.expasionPanelModel = undefined;
      }
    );

    this.dispose = () => {
      disposeOnFilterExpandedChanged();
    };
  }

  destroyed() {
    if (this.dispose) this.dispose();
  }
}
